import { Col, Row } from 'antd';
import React from 'react';
import { CustomTable, CustomText } from '../../../../components';

// Tipado recomendado
interface AssetData {
  id?: number;
  plate_code?: string;
  description?: string;
  asset?: string;
  class?: string;
  class_code?: string;
  item?: { id: string; name: string; code: string } | string;
  item_code?: string;
  asset_class?: { id: string; name: string; code: string };
  good_status?: { status: string };
  asset_status?: string;
  status?: string;
  assets_count?: number;
  assets?: AssetData[];
}

interface Props {
  items: AssetData[];
}

const AdditionalAssets: React.FC<Props> = ({ items }) => {
  const [item = {} as AssetData] = items;

  const renderClass = (_: any, record: AssetData) =>
    record.asset_class
      ? `${record.asset_class?.code ?? ''} - ${record.asset_class?.name ?? ''}`
      : `${record.class_code ?? ''} - ${record.class ?? ''}`;

  const renderItem = (_: any, record: AssetData) =>
    typeof record.item === 'object'
      ? `${record.item?.code ?? ''} - ${record.item?.name ?? ''}`
      : `${record.item_code ?? ''} - ${record.item ?? ''}`;

  const renderStatus = (_: any, record: AssetData) =>
    record.good_status?.status || record.asset_status || record.status || '—';

  const renderDescription = (
    _: any,
    record: AssetData,
    _index: number
  ): React.ReactNode => {
    if (typeof record.description === 'string') {
      return record.description;
    }

    if (typeof record.asset === 'string') {
      return record.asset;
    }

    return '—';
  };

  return (
    <>
      {/* Activo principal */}
      <Row style={{ marginBottom: '20px' }}>
        <Col xs={24} style={{ marginBottom: '16px' }}>
          <CustomText strong text="Activo principal" />
        </Col>
        <Col xs={24}>
          <CustomTable
            columns={[
              { title: 'Ítem', dataIndex: 'id', key: 'id', align: 'center' },
              {
                title: 'Código/Placa',
                dataIndex: 'plate_code',
                key: 'plate_code',
                align: 'center',
              },
              {
                title: 'Descripción',
                key: 'description',
                render: renderDescription,
              },

              {
                title: 'Clase de activo',
                key: 'asset_class',
                render: renderClass,
              },
              { title: 'Artículo', key: 'item', render: renderItem },
              {
                title: 'Adiciones',
                dataIndex: 'assets_count',
                key: 'assets_count',
                align: 'center',
              },
              {
                title: 'Estado del bien',
                key: 'good_status',
                render: renderStatus,
              },
            ]}
            dataSource={items}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>

      {/* Adiciones */}
      {!!item?.assets?.length && (
        <Row style={{ marginBottom: '20px' }}>
          <Col xs={24} style={{ marginBottom: '16px' }}>
            <CustomText strong text="Adiciones" />
          </Col>
          <Col xs={24}>
            <CustomTable
              columns={[
                {
                  title: 'Ítem',
                  key: 'index',
                  align: 'center',
                  render: (_: any, __: any, index: number) => index + 1,
                },
                {
                  title: 'Código/Placa',
                  dataIndex: 'plate_code',
                  key: 'plate_code',
                  align: 'center',
                },
                {
                  title: 'Descripción',
                  dataIndex: 'description',
                  key: 'description',
                  align: 'center',
                },
                {
                  title: 'Clase de activo',
                  key: 'asset_class',
                  render: renderClass,
                },
                { title: 'Artículo', key: 'item', render: renderItem },
                {
                  title: 'Estado del bien',
                  key: 'good_status',
                  render: renderStatus,
                },
              ]}
              dataSource={item.assets}
              scroll={{ x: 'max-content' }}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default AdditionalAssets;
